import React from 'react';
import {
  ApButtonGroup,
  ApButtonMain,
  ApButtonDanger,
  ApButtonSecondary,
} from '@alixpartners/ui-components';
import { StyledModal } from './NavigateUnsavedModal.styles';

interface IProps {
  isInvalid?: boolean;
  onConfirm(): void;
  onSave(): void;
  onClose(): void;
}

export const NavigateUnsavedModal: React.FC<IProps> = ({
  isInvalid,
  onConfirm,
  onSave,
  onClose,
}) => {
  return (
    <StyledModal
      isOpen={true}
      hasClosed={onClose}
      footer={({ handleClose }) => {
        return (
          <ApButtonGroup justifyContent="flex-end">
            <ApButtonSecondary onClick={handleClose}>Cancel</ApButtonSecondary>
            <ApButtonDanger onClick={onConfirm}>Do not save</ApButtonDanger>
            <ApButtonMain disabled={!!isInvalid} onClick={onSave}>
              Save allocation data
            </ApButtonMain>
          </ApButtonGroup>
        );
      }}
    >
      Do you want to save current spend allocation data?
    </StyledModal>
  );
};
